<template>
  <CardTable
    header="Past Leaks"
    :tableHeaders="headers"
    :tableData="pastAlerts.leakList"
  />
</template>

<script>
import serviceMixin from '@shared/mixins/serviceMixin';
import CardTable from '@shared/components/service/component/CardTable.vue';

export default {
  name: 'PastLeakAlertsTable',
  components: { CardTable },
  mixins: [serviceMixin],
  data() {
    return {
      headers: [{
        text: 'Date',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'startTime',
      }, {
        text: 'Serial',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'serial',
      }, {
        text: 'Location',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'location',
      }, {
        text: 'First Occurred',
        align: 'center',
        sortable: false,
        filterable: false,
        value: 'firstOccurred',
      }, {
        text: 'Last Occurred',
        align: 'start',
        sortable: false,
        filterable: false,
        value: 'lastOccurred',
      }],
    };
  },
};
</script>
